import { FONT_DISPLAY, FONT_MONO } from 'config';

// ==============================|| PRIVACYPAL THEME - TYPOGRAPHY ||============================== //
//
// Inter          → body / UI (passed in as `fontFamily`)
// Radley (serif) → display headlines (h1–h3), the brand's serif authority
// JetBrains Mono → overlines / kickers / labels (uppercase, tracked, teal)

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      fontSize: '2.375rem',
      lineHeight: 1.15,
      letterSpacing: '-0.02em'
    },
    h2: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      fontSize: '1.875rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em'
    },
    h3: {
      fontFamily: FONT_DISPLAY,
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.28,
      letterSpacing: '-0.01em'
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      fontFamily: FONT_MONO,
      fontWeight: 600,
      fontSize: '0.72rem',
      letterSpacing: '0.18em',
      textTransform: 'uppercase',
      lineHeight: 1.66
    },
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  };
}
